<template>
	<div>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader style="max-width: 555px" v-bind="attrs" type="card" v-if="isLoading">
			</v-skeleton-loader>
			<div
				v-if="!isLoading && uploads.length > 0"
				v-for="attachment in uploads"
				:key="uploads.id"
				class="mt-1"
			>
				<FileListComponent :attachment="attachment" />
			</div>
			<div v-if="!isLoading && isCurrentPageListEmpty" class="mt-5 align-center">
				<NewsFeedEmpty
					title="Action resources is empty at the moment."
					description="Check back later."
				/>
			</div>
			<div
				class="d-flex my-9 ma-auto justify-center home-page__pagination"
				v-if="!isLoading && uploads.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Pagination from '@/components/Pagination.vue'
import ButtonBack from '@/components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import Filter from '@/mixins/Filter'
import FileListComponent from '@/components/FileListComponent.vue'

export default {
	name: 'ActionResourcePage',
	mixins: [Block, Dwh, Filter],
	components: {
		NewsFeedEmpty,
		Pagination,
		ButtonBack,
		PageBlocked,
		FileListComponent,
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'listMeta']),
		...mapGetters('event', ['actionFiles', 'actionFilesMeta', 'isLoading', 'event']),

		uploads() {
			if (!this.actionFiles && this.actionFiles.length > 0) {
				return []
			}
			return this.actionFiles
		},
		isCurrentPageListEmpty() {
			const isFilesEmpty = this.uploads.length <= 0
			return isFilesEmpty
		},
		pageCount() {
			if (this.actionFilesMeta && this.uploads.length > 0) {
				return +this.actionFilesMeta.pageCount
			}

			return 0
		},
		pageTitle() {
			return this.$route.query.title || null
		},
	},
	methods: {
		...mapActions('event', ['getActionLinks', 'getActionFiles']),
		...mapActions('app', ['setPageTitle']),
		getResources(queryString) {
			this.getActionFiles({ id: this.$route.params.actionId, queryString })
		},
	},
	watch: {
		uploads(newValue) {
			if (newValue.length) {
				const triggerPayload = {
					category: 'Content',
					action: 'view_action_list_of_files_event',
					module: 'Events',
					content_chapter_id:
						this.event && this.event.chapter_id ? [this.event.chapter_id] : null,
				}
				if (this.$route.query.title) {
					triggerPayload.title = this.$route.query.title
				}
				this.sendTrigger(triggerPayload)
			}
		},
	},
	data() {
		return {
			successMessage: false,
			errorMessage: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'events',
		}
	},
	created() {
		if (
			this.$route.params.eventId !== undefined &&
			this.$route.params.actionId !== undefined &&
			(!this.isBlocked || this.isBlocked === null)
		) {
			this.getActionFiles(this.requestQuery)
		}
	},
	mounted() {
		this.setPageTitle(this.pageTitle)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
}
</script>

<style lang="scss"></style>
